const isWindowsPlatform = () => {
  return typeof navigator !== "undefined" && navigator.userAgent.indexOf("Windows") > -1;
};

export { isWindowsPlatform };
//# sourceMappingURL=global.js.map
